import { $authHost } from "../../http";
import { 
    REFERRAL_ORDER_TYPE_GET_REQUEST, REFERRAL_ORDER_TYPE_GET_SUCCESS, REFERRAL_ORDER_TYPE_GET_ERROR, 
    REFERRAL_ORDER_TYPE_GET_BY_KEY_REQUEST, REFERRAL_ORDER_TYPE_GET_BY_KEY_SUCCESS, REFERRAL_ORDER_TYPE_GET_BY_KEY_ERROR, 
    REFERRAL_ORDER_TYPE_ADD_REQUEST, REFERRAL_ORDER_TYPE_ADD_SUCCESS, REFERRAL_ORDER_TYPE_ADD_ERROR, 
    REFERRAL_ORDER_TYPE_EDIT_REQUEST, REFERRAL_ORDER_TYPE_EDIT_SUCCESS, REFERRAL_ORDER_TYPE_EDIT_ERROR, 
    REFERRAL_ORDER_TYPE_DELETE_REQUEST, REFERRAL_ORDER_TYPE_DELETE_SUCCESS, REFERRAL_ORDER_TYPE_DELETE_ERROR
} from "../constants/referralOrderTypeConstants";

export const getReferralOrderTypes = (args) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ORDER_TYPE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/referralOrderType/query",
            args || {},
            config,
        );
        dispatch({
            type: REFERRAL_ORDER_TYPE_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REFERRAL_ORDER_TYPE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getReferralOrderTypeByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ORDER_TYPE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/referralOrderType/${id}`,
        );
        dispatch({
            type: REFERRAL_ORDER_TYPE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: REFERRAL_ORDER_TYPE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addReferralOrderType = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ORDER_TYPE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/referralOrderType",
            { name, code, description },
            config,
        );
        dispatch(getReferralOrderTypes(queryArgs || {}));
        dispatch({
            type: REFERRAL_ORDER_TYPE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_ORDER_TYPE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editReferralOrderType = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ORDER_TYPE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/referralOrderType",
            { id, name, code, description },
            config,
        );
        dispatch(getReferralOrderTypes(queryArgs || {}));
        dispatch({
            type: REFERRAL_ORDER_TYPE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_ORDER_TYPE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteReferralOrderType = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: REFERRAL_ORDER_TYPE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/referralOrderType",
            { data: { id } },
            config,
        );
        dispatch(getReferralOrderTypes(queryArgs || {}));
        dispatch({
            type: REFERRAL_ORDER_TYPE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: REFERRAL_ORDER_TYPE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

